@if (showFilter) {
  <mat-form-field subscriptSizing="dynamic">
    <mat-label i18n>Filter</mat-label>
    <input matInput [(ngModel)]="dataSource.filter" />
  </mat-form-field>
}

<mat-table [dataSource]="dataSource" matSort [matSortActive]="defaultSortColumn" [matSortDirection]="defaultSortDirection">
  <!-- User name Definition -->
  <ng-container matColumnDef="type">
    <mat-header-cell *matHeaderCellDef i18n mat-sort-header="taskName">Aufgabe</mat-header-cell>
    <mat-cell *matCellDef="let row">
      <div class="task-title-container">
        <div>{{ row.taskName }}</div>
        @if (row.taskNameSubtitle) {
          <div class="task-subtitle">{{ row.taskNameSubtitle }}</div>
        }
      </div>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="assignedTo">
    <mat-header-cell *matHeaderCellDef i18n mat-sort-header="assignedTo.displayName">Zugewiesen zu</mat-header-cell>
    <mat-cell *matCellDef="let row">
      <dt-team-member-name [member]="row.assignedTo" [showEmailWhenNoName]="true"></dt-team-member-name>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="created">
    <mat-header-cell *matHeaderCellDef i18n mat-sort-header="task.createdAt">Zugewiesen</mat-header-cell>
    <mat-cell *matCellDef="let row">{{ row.task.createdAt | date: 'short' }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="modified">
    <mat-header-cell *matHeaderCellDef i18n mat-sort-header="task.updatedAt">Zuletzt geändert</mat-header-cell>
    <mat-cell *matCellDef="let row">{{ row.task.updatedAt | date: 'short' }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="state">
    <mat-header-cell *matHeaderCellDef i18n mat-sort-header>Status</mat-header-cell>
    <mat-cell *matCellDef="let row">
      <div class="state">
        <span>{{ row.state[1] }}</span>
        @if (row.state[2]) {
          <span>{{ row.state[2] }}</span>
        }
      </div>
    </mat-cell>
  </ng-container>

  <!-- Header and Row Declarations -->
  <mat-header-row *matHeaderRowDef="shownColumns; sticky: true"></mat-header-row>
  <mat-row
    *matRowDef="let row; let index = index; columns: shownColumns"
    (click)="openTaskModal(row)"
    class="task-row"
    [class.grayed-out]="row.state[0] === 'done' || row.state[0] === 'submitted' || row.state[0] === 'applied'"
  ></mat-row>
</mat-table>
